'use client';

import './e-commerce.css';
import Card1Data from '../../../textContent/e-commerce/Card1Data.json';
import Card2Data from '../../../textContent/e-commerce/Card2Data.json';
import Data2 from '../../../textContent/servicesHeroContent/e-commerce';
import { Fragment } from 'react';
import Rocket from '../../../components/Rocket';
import ServicesHero from '@/components/ServicesHero';
import VideoTextCard from '@/components/VideoTextCard';
import jsonData2 from '../../../textContent/rocket/rocket2.json';
import { motion } from 'framer-motion';

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
};

const page = () => {
    return (
        <Fragment>
            <div>
                {/* ===== HERO SECTION ===== */}
                <motion.div
                    id="mainecommerce"
                    className="w-full py-5 md:pt-6 pt-16 px-6 flex flex-col items-center justify-center"
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    <ServicesHero data={Data2} />
                </motion.div>

                {/* ===== VIDEO TEXT CARDS ===== */}
                <div className="px-4 md:pt-20 pt-1">
                    <motion.div
                        className="p-1 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                    >
                        <VideoTextCard data={Card1Data} />
                    </motion.div>

                    <motion.div
                        className="p-1 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                    >
                        <VideoTextCard data={Card2Data} />
                    </motion.div>
                </div>

                {/* ===== ROCKET SECTION ===== */}
                <motion.div
                    id="rocket"
                    className="flex items-center justify-center my-10"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    <Rocket jsonData={jsonData2} />
                </motion.div>
            </div>
        </Fragment>
    );
};

export default page;
